<div
  class="why-choose-us bg-blue bg-choose-us-one bg_image rts-section-gap shape-move"
  id="career"
>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="why-choose-us-area-image pb--50">
          <img
            class="one"
            src="assets/images/why-choose/02.jpg"
            alt="why-choose"
          />
          <div class="border-img">
            <img
              class="two ml--20"
              src="assets/images/why-choose/03.jpg"
              alt="why-choose"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-6 pl--90 pl_md--15 mt_md--50 pl_sm--15 pt_sm--50">
        <div class="title-area-left-style">
          <h2 class="title">Você já sai com todo o preparo para o mercado</h2>
          <p class="post-title">
            Aqui você tem programas de estágio e orientações para conquistar sua
            vaga.
          </p>
        </div>
        <div class="why-choose-main-wrapper-1">
          <div class="row g-3 justify-content-center">
            <div
              class="col-12 col-sm-6 col-md-4 col-lg-6 d-flex"
              *ngFor="let card of cards"
            >
              <div
                class="single-choose-reason-1 d-flex flex-column align-items-start"
                [ngStyle]="{
                  height: '100%',
                  'min-width': '100%'
                }"
              >
                <div class="icon">
                  <img
                    [src]="card.icon"
                    height="40px"
                    width="40px"
                    alt="icon"
                  />
                </div>
                <div class="single-fun-facts w-100">
                  <h5 class="title">
                    {{ card.prefix
                    }}<span class="counter">{{ card.number }}</span
                    >{{ card.suffix }}
                  </h5>
                  <span class="enr">{{ card.text }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          href="https://matricula.virtualfacint.com.br"
          class="rts-btn btn-primary-white with-arrow"
        >
          Inscreva-se<i class="fa-solid fa-arrow-right"></i
        ></a>
      </div>
    </div>
  </div>
  <div class="shape-image">
    <div class="shape one" data-speed="0.04" data-revert="true">
      <img src="assets/images/banner/15.png" alt="" />
    </div>
    <div class="shape two" data-speed="0.04">
      <img src="assets/images/banner/shape/banner-shape02-w.svg" alt="" />
    </div>
    <div class="shape three" data-speed="0.04">
      <img src="assets/images/cta/03.svg" alt="" />
    </div>
  </div>
</div>
